import { resolveInteractionMode } from '@/shared-question-model';

import {
  RESPONSE_MODES,
  type ResponseMode,
} from './shared-responder-v2-core-session.consts';
import { getThreadBehaviour } from './shared-responder-v2-core-thread-registry';
import {
  THREAD_KINDS,
  type ThreadKind,
} from './shared-responder-v2-core-thread.consts';

export function resolveEffectiveInteractionType(args: {
  projectInteractionType: ResponseMode;
  questionInteractionType: ResponseMode | null;
  hasUrlOrTask: boolean;
  kind: ThreadKind;
  allowVoice: boolean;
}): ResponseMode {
  // /manager-embed runs inside an iframe where `mediaDevices` is commonly
  // blocked by permissions policy, so voice can never work there.
  if (!args.allowVoice) {
    return RESPONSE_MODES.Text;
  }

  const resolvedMode = resolveInteractionMode(
    args.questionInteractionType,
    args.projectInteractionType
  );

  if (resolvedMode !== RESPONSE_MODES.Voice) {
    return RESPONSE_MODES.Text;
  }

  const isExemptFromTaskSuppression =
    args.questionInteractionType === RESPONSE_MODES.Voice &&
    getThreadBehaviour(args.kind).recordsVoiceWhenUrlPresent;

  const isSuppressedByTask =
    args.hasUrlOrTask &&
    args.projectInteractionType === RESPONSE_MODES.Text &&
    !isExemptFromTaskSuppression;

  return isSuppressedByTask ? RESPONSE_MODES.Text : RESPONSE_MODES.Voice;
}

/**
 * In voice mode, a Contact Info question — or an open-ended question left in
 * text mode — is still answered by typing, but the microphone stays enabled
 * so the responder can switch back to speaking mid-question.
 */
export function shouldKeepMicrophoneLive(args: {
  mode: ResponseMode;
  kind: ThreadKind;
}): boolean {
  return (
    args.mode === RESPONSE_MODES.Voice &&
    (args.kind === THREAD_KINDS.ContactInfo ||
      args.kind === THREAD_KINDS.OpenEnded)
  );
}
